import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ProjectPlanningService } from '../../../modules/p-dashboard/project-planning/project-planning.service';
import { Project360Service } from '../../../modules/p-dashboard/project360.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { MatSlider } from '@angular/material/slider';
import { ActivityPayload } from '../../../models/phases.model';

@Component({
  selector: 'app-all-activities-today',
  templateUrl: './all-activities-today.component.html',
  styleUrls: ['./all-activities-today.component.scss'],
})
export class AllActivitiesTodayComponent implements OnInit {
  phasesActivities: any;
  displayedActivitiesColumns: string[] = ['phase_name', 'name', 'completion_percentage'];

  private totalActivities: number = 0;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Input() isDashboard;

  constructor(
    public _projectPlanning: ProjectPlanningService,
    private _project: Project360Service,
    private _toaster: ToastrService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.getActivities(1, 5);
  }

  onPaginatorPageChange(event: PageEvent) {
    const pageNumber = event.pageIndex + 1;
    const pageSize = event.pageSize;
    this.getActivities(pageNumber, pageSize);
  }

  getActivities(pageNumber: number, pageSize: number) {
    this._projectPlanning
      .fetchPhasesActivities(
        {
          project_id: this._project.id,
          date: moment(new Date()).locale('en').format('YYYY-MM-DD'),
          sort: 'oldest',
        },
        pageNumber,
        pageSize,
      )
      .then((totalActivities: number) => {
        this.totalActivities = totalActivities;
        this.phasesActivities = this._projectPlanning.phasesActivities;
        this.phasesActivities.paginator = this.paginator; // Assign the paginator reference to the updated data source
      })
      .catch((error) => {
        console.error('Error fetching phases activities:', error);
      });
  }

  onCompletionPercentageChange(element: ActivityPayload) {
    this._projectPlanning
      .updateActivity(element, element.phase_id, this._project.id)
      .catch((e: HttpErrorResponse) => {
        if (e.error.error) {
          this._toaster.error(e.error.error[0]);
        } else {
          this._toaster.error(e.error.toString());
        }
      });
  }

  isArabic() {
    let currentLang = localStorage.getItem('lang');
    return currentLang === 'ar' ? 'rtl' : 'ltr';
  }
  onSliderMouseUp(sliderRef: MatSlider) {
    sliderRef.blur();
  }
}
